<div class="grid-container">
    <div class="menu-hamburger">
        <div>
            <!-- TODO: Fazer depois -->
            <!-- <i class="pi pi-bars"></i> -->
        </div>
    </div>
    <div class="logo-menu">
        <img src="../../assets/logo/menu-logo.svg"/>
    </div>
    <div>
        <erp-avatar></erp-avatar>
    </div>
    <div class="menu-grid">
        <erp-sidebar></erp-sidebar>
    </div>
    <div class="main-content">
        <router-outlet></router-outlet>
    </div>
</div>